import { useState, useCallback } from 'react';
import { LoopState } from '../../types/player';

export const useLoopControl = (
  exitFullscreenTemporarily: () => Promise<boolean>,
  restoreFullscreen: () => Promise<boolean>,
) => {
  const [loopStart, setLoopStart] = useState<number | null>(null);
  const [loopEnd, setLoopEnd] = useState<number | null>(null);
  const [isLoopModalOpen, setIsLoopModalOpen] = useState(false);

  // Computed loop state
  const loopEnabled = loopStart !== null && loopEnd !== null;

  // Open loop modal (exiting fullscreen if needed)
  const openLoopModal = useCallback(async () => {
    const wasFullscreen = await exitFullscreenTemporarily();

    // Use timeout to prevent flickering during transition
    setTimeout(
      () => {
        setIsLoopModalOpen(true);
      },
      wasFullscreen ? 150 : 0,
    );
  }, [exitFullscreenTemporarily]);

  // Close loop modal (restoring fullscreen if needed)
  const closeLoopModal = useCallback(async () => {
    setIsLoopModalOpen(false);

    // Use timeout to allow modal to close before fullscreen transition
    setTimeout(async () => {
      await restoreFullscreen();
    }, 150);
  }, [restoreFullscreen]);

  // Clear loop points
  const clearLoop = useCallback(() => {
    setLoopStart(null);
    setLoopEnd(null);
  }, []);

  return {
    loopStart,
    loopEnd,
    isLoopModalOpen,
    loopEnabled,
    setLoopStart,
    setLoopEnd,
    openLoopModal,
    closeLoopModal,
    clearLoop,
  };
};
